<div class="app-bg scroll-fix">

    <div class="container container-padding">

        <h1 class="page-header">{{ 'CALCULATION_SUMMARY' | translate }}</h1>

        <div class="separator"></div>

        <div class="box box-white has-shadow">
            <div class="box-content">
                <div class="box-body">
                    <div class="box-row">
                        <div class="box-item">
                            <div class="row">
                                <div class="col-auto">
                                    <app-output [label]="'POLICY_DATE_AND_CITY' | translate">
                                        <ng-container *ngIf="!offer.additionalData.location">
                                            {{ offer.statusDate | lsnDate }}
                                        </ng-container>
                                        <ng-container *ngIf="offer.additionalData.location">
                                            {{ offer.statusDate | lsnDate }}, {{ offer.additionalData.location }}
                                        </ng-container>
                                    </app-output>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="separator"></div>

        <app-clients-summary-box [document]="offer"
                                 [readonly]="true">
        </app-clients-summary-box>

        <div class="separator"></div>

        <app-motor-summary-box [document]="offer"
                               [configurationType]="configurationTypes.FRONTIER"
                               [fullInsuranceDate]="false"
                               [readonly]="true">
        </app-motor-summary-box>

        <div class="separator"></div>

        <div class="box mt-3 " *ngIf="offer.premium !== null">
            <div class="box-body">
                <div class="row no-gutters">
                    <div class="col">
                    </div>
                    <div class="col-auto">
                        <div class="text-price ml-0">
                            <div class="item-text">{{'OFFER_CONFIG.TOTAL_PREMIUM' | translate}}</div>
                            <div class="item-price" *ngIf="offer.premium !== 0">{{ offer.premium | premium }}</div>
                            <div class="item-price" *ngIf="offer.premium === 0">-</div>
                        </div>
                        <app-errors [errorStateMatcher]="matchers.premium"></app-errors>
                    </div>
                </div>
            </div>
        </div>

        <div class="separator"></div>

        <app-clauses [offer]="offer"
                     prefix="clausesRequest."
                     [readonly]="readonly">
        </app-clauses>

        <div class="row form-row" *ngIf="matchers.generic.errors.length > 0">
            <div class="col">
                <app-message-box [errorStateMatcher]="matchers.generic"></app-message-box>
            </div>
        </div>

        <hr class="dimmed mt-4">

        <div class="row">
            <div class="col">
                <button *ngIf="isSeller"
                        [routerLink]="['/frontier', offer.id, 'card']"
                        class="btn btn-secondary">
                    {{ 'BUTTON.BACK' | translate }}
                </button>
            </div>
            <div class="col-auto" *ngIf="!readonly && hasFinishedProducts">
                <button (click)="issue()"
                        class="btn btn-primary">
                    {{ 'LABEL.SUBMIT_CALCULATION' | translate }}
                </button>
            </div>
        </div>
    </div>
</div>
